import { render, staticRenderFns } from "./FileAttachmentPreview.vue?vue&type=template&id=32d214c0&"
import script from "./FileAttachmentPreview.vue?vue&type=script&lang=ts&setup=true&"
export * from "./FileAttachmentPreview.vue?vue&type=script&lang=ts&setup=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports